import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';

export function useClipboard() {
    const [isCopied, setIsCopied] = useState<string | null>(null);

    const copyToClipboardFallback = (text: string) => {
        const textarea = document.createElement('textarea');
        textarea.textContent = text;
        textarea.style.position = 'fixed';
        document.body.appendChild(textarea);
        textarea.select();

        try {
            return document.execCommand('copy');
        } catch (error) {
            console.warn('Copy to Clipboard Fallback failed', error);
            return false;
        } finally {
            document.body.removeChild(textarea);
        }
    };

    const copyToClipboard = useCallback(async (text: string) => {
        if (!navigator?.clipboard) {
            console.warn('Clipboard API not available');
            return copyToClipboardFallback(text);
        }

        try {
            await navigator.clipboard.writeText(text);
            setIsCopied(text);
            toast.success('Copied to clipboard', { autoClose: 1500 });
            setTimeout(() => setIsCopied(null), 2000);
            return true;
        } catch (error) {
            toast.error('Error copying to clipboard');
            console.warn('Copy failed', error);
            return false;
        }
    }, []);

    const reset = useCallback(async () => {
        setIsCopied(null);
        await navigator.clipboard.writeText('');
    }, []);

    return { isCopied, copyToClipboard, reset };
}
